import { CloseTemplateViewConfig } from "@common/types/closeTemplateViewConfig";
import { TaskType } from "@common/types/task";
import { useScope } from "@state/scopeContext.lib";
import {
    ORG_LEVEL_COUNTERPARTIES_FILTER_TABS,
    WORKSPACE_COUNTERPARTIES_FILTER_TABS,
} from "@components/tasks/TaskBody/Counterparties/counterpartiesTaskFilters";
import {
    defaultCounterpartiesView,
    parseCounterpartiesTaskView,
    serializeCounterpartiesTemplateView,
} from "@components/tasks/TaskBody/Counterparties/counterpartiesTaskView";
import { CloseTemplateCounterpartyDataPreview } from "./CloseTemplateCounterpartyDataPreview";

interface Props {
    viewConfig: CloseTemplateViewConfig | null;
    onViewConfigChange: (viewConfig: CloseTemplateViewConfig) => void;
}

export const CloseTemplateTaskCounterpartiesPreview: React.FC<Props> = ({
    viewConfig,
    onViewConfigChange,
}) => {
    const { workspaceId } = useScope();

    return (
        <CloseTemplateCounterpartyDataPreview
            taskType={TaskType.COUNTERPARTIES}
            viewConfig={viewConfig}
            onViewConfigChange={onViewConfigChange}
            parseViewConfig={parseCounterpartiesTaskView}
            serializeView={serializeCounterpartiesTemplateView}
            createDefaultView={defaultCounterpartiesView}
            availableFilters={
                workspaceId
                    ? WORKSPACE_COUNTERPARTIES_FILTER_TABS
                    : ORG_LEVEL_COUNTERPARTIES_FILTER_TABS
            }
        />
    );
};
